import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const PrivacyPolicy: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 p-6 pb-24">
            <div className="flex items-center gap-4 mb-6">
                <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full">
                    <ArrowLeft size={24} />
                </button>
                <h1 className="text-2xl font-bold">Privacy Policy</h1>
            </div>

            <div className="prose dark:prose-invert max-w-none space-y-4">
                <p className="text-sm text-gray-500">Last updated: December 25, 2025</p>

                <section>
                    <h2 className="text-xl font-bold mb-2">1. Introduction</h2>
                    <p>
                        Welcome to AR Draw: Trace & Sketch. We respect your privacy and are committed to protecting your personal data.
                        This privacy policy will inform you as to how we look after your personal data when you visit our application
                        and tell you about your privacy rights and how the law protects you.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-bold mb-2">2. Camera Usage</h2>
                    <p>
                        Our app requires access to your device's camera to function. The camera is used solely for the purpose of
                        displaying the Augmented Reality (AR) overlay to help you draw. We do not record, store, or transmit
                        any video or images from your camera to our servers unless you explicitly choose to save a recording
                        to your device's gallery or share it.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-bold mb-2">3. Data Collection</h2>
                    <p>
                        We use Google Firebase and AdMob services which may collect anonymous usage data and identifiers to
                        improve app performance and serve relevant advertisements.
                    </p>
                    <ul className="list-disc pl-5 space-y-1">
                        <li><strong>Firebase Auth:</strong> Used for user authentication.</li>
                        <li><strong>Firebase Firestore:</strong> Used to store user profiles and community posts.</li>
                        <li><strong>AdMob:</strong> Used to display advertisements.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-bold mb-2">4. Contact Us</h2>
                    <p>
                        If you have any questions about this privacy policy, please contact us at:
                        <br />
                        <a href="mailto:support@ardraw.com" className="text-indigo-600 dark:text-indigo-400">support@ardraw.com</a>
                    </p>
                </section>
            </div>
        </div>
    );
};
